"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onlineWatcher = exports.getWindow = exports.offlineWatcher = void 0;
var rxjs_1 = require("rxjs");
function offlineWatcher(win) {
    return rxjs_1.fromEvent(win, 'offline');
}
exports.offlineWatcher = offlineWatcher;
function getWindow(win) {
    return win ? win : window;
}
exports.getWindow = getWindow;
function onlineWatcher(win) {
    return rxjs_1.fromEvent(win, 'online');
}
exports.onlineWatcher = onlineWatcher;
//# sourceMappingURL=window.js.map